































































import { faUserEdit } from '@fortawesome/free-solid-svg-icons'
import { mapGetters } from 'vuex'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { Seller } from '~/models/classified/types'

export default defineComponent({
  props: {
    seller: {
      type: Object as PropType<Seller>,
      required: true
    },
    gotonext: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      icons: {
        userEdit: faUserEdit
      }
    }
  },
  computed: {
    ...mapGetters(CLASSIFIED_VIEW_NS, ['isPlotClassified']),
    nameToDisplay() {
      return this.seller.name || this.seller.displayName || this.seller.username
    },
    loginAsUserUrl() {
      return `/loginas/${this.seller.id}/?goto=${this.gotonext ||
        this.$route.fullPath}`
    },
    agentEditUrl() {
      return `https://www.plot.gr/admin/users/${this.seller.id}/edit/`
    }
  }
})
